
/**
 * 歌曲 Model
 */
import cloneDeep from 'lodash-es/cloneDeep'
import { toPreview } from '@/utils/fileUtil'

// 付费信息
const trackPayment = {
  price: 0,
  paymentMode: 1,
  freeDuration: 0
}

const extend = {
  wordAuthor: '',
  musicAuthor: '',
  arrangeAuthor: '',
  producer: '',
  parentGuidance: '',
  subTitle: '',
  tvName: '',
  createBg: '',
  awardRecord: '',
  srcMusic: 0,
  srcTrack: 0,
  srcSingerName: '',
  trackDesc: '',
  productionCompanyName: '',
  subGenre: ''
}

export const defaultCopyright = {
  cpCompany: '',
  originCpCompany: {
    companyName: ''
  },
  copyright: '',
  date: [],
  isAgent: 0,
  isOnly: 0,
  canAuth: 0,
  // authProduct: [],
  copyrightArea: [],
  cpSource: 2,
  isOverseaOnly: 0,
}
export default class Song {
  lockCopyright = false
  lockMusic = false
  lockWord = false
  lockBasic = false
  mediaFinish = false
  uploadPercent = 0
  hasError = false

  constructor(initObj = {}) {
    let trackLicenseList = []
    const trackExtend = {
      ...extend,
      ...initObj.trackExtend
    }
    const tp = {
      ...trackPayment,
      ...initObj.payment,
    }

    // 艺人
    const singerList = parseSinger(initObj.singerList)
    const trackComposerList = parseSinger(initObj.trackComposerList)
    const trackLyricistList = parseSinger(initObj.trackLyricistList)
    const trackArrangerList = parseSinger(initObj.trackArrangerList)
    const trackProducerList = parseSinger(initObj.trackProducerList)

    trackExtend.subGenre = trackExtend.subGenre
      ? trackExtend.subGenre.split(',').map(v => +v)
      : []

    if (initObj.trackLicenseList) {
      trackLicenseList = initObj.trackLicenseList.map(license => {
        return {
          ...license,
          name: license.fileName,
          url: toPreview(license.licenseUrl)
        }
      })
    }

    if (initObj.album) {
      const album = initObj.album
      this.albumObj = initObj.album
      this.albumId = `${album.albumId} -@- ${album.albumName}`
    }

    this.tempId = initObj.trackId || `tempId_${Date.now()}`
    this.trackId = initObj.trackId
    this.tmeTrackId = initObj.tmeTrackId
    this.trackName = initObj.trackName || ''
    this.transName = initObj.transName || ''
    this.location = initObj.location != null ? initObj.location : 1
    this.cdIndex = initObj.hasOwnProperty('cdIndex') ? initObj.cdIndex : 0
    this.srcVersion = initObj.srcVersion ?? undefined
    this.isrc = initObj.isrc || ''
    this.iswc = initObj.iswc || ''
    this.language = initObj.language ? initObj.language : 0
    // this.srcGenre = initObj.srcGenre ? initObj.srcGenre.split('|') : []
    this.publicTime = initObj.publicTime
    this.saleTime = initObj.saleTime
    this.createUser = initObj.createUser || ''
    this.fFrom = initObj.fFrom || 22 // 开放平台上传
    this.insertTime = initObj.insertTime
    this.modifyTime = initObj.modifyTime
    this.firstPublicTime = initObj.firstPublicTime || null
    this.status = initObj.status || 0
    this.trackSingerList = singerList
    this.trackComposerList = trackComposerList
    this.trackLyricistList = trackLyricistList
    this.trackArrangerList = trackArrangerList
    this.trackProducerList = trackProducerList
    this.media = initObj.media ? initObj.media : null
    this.trackExtend = trackExtend
    this.trackPayment = tp
    this.lyricData = initObj.lyricData || {}
    this.trackCopyright = initObj.trackCopyright || cloneDeep(defaultCopyright)
    this.trackLicenseList = trackLicenseList
    this.trackWordCopyrightList = initObj.trackWordCopyrightList || []
    this.trackMusicCopyrightList = initObj.trackMusicCopyrightList || []
    this.trackInstrument = initObj.trackInstrument || {}
    this.trackCopyrightCompetitor = initObj.trackCopyrightCompetitor || { copyrightTo: null }

    this.genre = initObj.genre
      ? initObj.genre.split(',').map(v => +v)
      : []
    this.trackNumber = initObj.trackNumber || ''
  }
}

function parseSinger(singerList) {
  return (singerList || []).map(singer => {
    const value = singer.singerName
    return {
      ...singer,
      value,
      label: value,
    }
  })
}
